export const rankings = ["צב", "דבורה", "חד קרן", "קואלה", "חתול", "סוס", "תולעת", "אריה",];